import { ROLE_PERMISSIONS, type Permission } from '@/constants/permissions';
import type { AuthUser, Role } from '@/types/auth';

export function getPermissionsForRoles(roles: Role[]): Set<Permission> {
  const permissions = new Set<Permission>();
  for (const role of roles) {
    for (const permission of ROLE_PERMISSIONS[role] ?? []) {
      permissions.add(permission);
    }
  }
  return permissions;
}

export function hasRole(user: AuthUser | null | undefined, role: Role): boolean {
  return Boolean(user?.roles.includes(role));
}

export function hasAnyRole(user: AuthUser | null | undefined, roles: Role[]): boolean {
  if (roles.length === 0) return true;
  return Boolean(user && roles.some((role) => user.roles.includes(role)));
}

export function hasPermission(user: AuthUser | null | undefined, permission: Permission): boolean {
  if (!user) return false;
  return getPermissionsForRoles(user.roles).has(permission);
}

export function hasAnyPermission(user: AuthUser | null | undefined, permissions: Permission[]): boolean {
  if (permissions.length === 0) return true;
  if (!user) return false;
  const granted = getPermissionsForRoles(user.roles);
  return permissions.some((permission) => granted.has(permission));
}
